<template>
  <div class="reset-success">
    <Icon></Icon>
    <div class="title">Your password has been reset</div>
    <Iconsuccess style="margin-top: 65px;"></Iconsuccess>
    <Foot :type="'Going back to sign in page'" style="margin-top: 55px;"></Foot>
  </div>
</template>

<script>
  import Icon from '../components/Icon'
  import Iconsuccess from '../components/Iconsuccess'
  import Foot from '../components/Foot'
  export default {
    data () {
      return {
      }
    },
    components: {
      Icon, Iconsuccess, Foot
    },
    mounted () {
    }
  }
</script>

<style lang="less" scoped>
	@import '../../assets/css/_mixin.less';
  .reset-success {
    .white-bg();
    height: 460px;
    margin-top: -230px;
    .title {
      width: 300px;
      margin: 0 auto;
      margin-top: 40px;
      color: #666666;
      text-align: center;
    }
    .code {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 45px;
    }
  }
</style>



// WEBPACK FOOTER //
// Resetsuccess.vue?d0e08616